import React from "react";
import { FormattedMessage } from "react-intl";
import numeral from "numeral";

const TooltipTabWithholding = ({data}) => {

  const tooltipContent = data?.deferredData?.flatMap(d => {
    return (
      [
        {
          title: "Causale prestazione",
          description: d?.reason.toLowerCase()
        },
        {
          title: "Causale cu",
          description: d?.cuReason.toLowerCase()
        },
        {
          title: "Contributi integrativo (cpa)",
          description: d?.cpa
        },
        {
          title: "% ritenuta",
          description: `${d?.withholdingPercent}% ${numeral(Math.abs(d?.withholdingAmount)).format("0,0.00")} €`
        }
      ]
    );
  });

  return (
    <>
      <h4 className="tooltip-title"><FormattedMessage id="preCog.accountingTab.tooltipTitle" values={{type: data?.doc?.active ? "vendita" : "acquisto"}}/></h4>
      {tooltipContent.map((t, index) => {
        return (
          <div className="tooltip-row" key={`tooltip-row_${index}`}>
            <div className="inner-row">
              <b className="title">{t.title}</b>
            </div>
            <div className="inner-row">
              <p className="description">{t.description}</p>
            </div>
          </div>
        );
      })
      }
    </>
  );
};

export default TooltipTabWithholding;